import { render, staticRenderFns } from "./HowDoesItWorkSmallSize.vue?vue&type=template&id=75401d68&"
import script from "./HowDoesItWorkSmallSize.vue?vue&type=script&lang=js&"
export * from "./HowDoesItWorkSmallSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports